const style = {
  display: "flex",
  flexDirection: "column",
  margin: "14px 0 14px 6px",
  gap: 6
};

export function AnimeInfoContainer(props) {
  return (<>
    <div style={ style }>{ props.children }</div>
  </>);
}
